<template>
  <div class="user__global__alert global__alert">
    <b-modal v-model="confirmDeleteAlert" type="warn" title="Confirm Deletion" @ok="deleteAlert(deleteAlertId)" ok-title="Yes, Delete">
        <p>Are you sure you want to delete this alert?</p>
    </b-modal>
    <b-modal
      size="lg"
      hide-footer
      id="userGlobalAlertDetail"
      class="modal-global-alert-detail"
    >
      <template slot='modal-title'>
        {{alertTitle}}
        <p class="notification-sender">
          sent by {{ alertSender }} @ {{ getLocalAlertTime(alertTime) }}
        </p>
      </template>
      <span v-html="alertDetail"></span>
    </b-modal>
    <HeaderControls />
    <div class="fixed-top-bar-padding">
        <div class="container-fluid">
            <div class="deliverable-header">
                <h2>
                    <div class="media-call-icon pointer-default">
                        <img width="30px" src="@/csmworkflow/img/bell-module.svg"/>
                    </div>
                    Your Messages
                </h2>
            </div>
        </div>

        <div class="container-fluid">
            <div class="global-alerts-status">
                <span v-if="typeof userAlerts.data != 'undefined' && userAlerts.data.length == 0"><h2>You have no notifications.</h2></span>
                <div class="alert-item clearfix">
                    <ul v-if="typeof userAlerts.data != 'undefined' && userAlerts.data.length > 0" class="list-unstyled">
                        <li
                        :key="'alert-'+index" 
                        v-for="(alert,index) in userAlerts.data" 
                        @click="seltAlert(alert)" 
                        class="cursor-pointer"
                        :class="alert.status == 0 ? 'unread-notification' : 'read-notification'"
                        >
                            <div>
                                <span class="info-bubbles">
                                    <span class="initials badge badge-primary cursor-pointer">
                                        {{ alert.sender | textInitials }}
                                    </span>
                                </span>
                                <span @click.stop="confirmDeleteAlert=true; deleteAlertId = alert.id;" class="remove-alert cursor-pointer">
                                    <i class="fas fa-trash"></i>
                                </span>
                                <span v-if="alert.status == 0" class="alert-status">
                                    <i class="fas fa-circle" :class="alert.status == 0 ? 'text-primary' : 'text-primary'" v-b-tooltip.hover :title="alert.status == 0 ? 'Unread' : 'Read'"></i>
                                </span>
                                <p class="details">
                                    <span class="alert__name cursor-pointer fw-bold">{{ alert.title }}</span>
                                    <br>
                                    <span class="notification-sender">
                                        <span class="fw-bold">{{ alert.sender }} @ {{ getLocalAlertTime(alert.created_at) }}</span>
                                    </span>
                                    <br>
                                    <span class="note-message" v-if="alert.message.length > 120">
                                        {{alert.message.substring(0, 120)+'...' | striphtml}}
                                    </span>
                                    <span class="note-message" v-else>
                                        {{alert.message | striphtml}}
                                    </span>
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
                <!-- <table class="table table-striped table-bordered table-hover" v-if="typeof userAlerts.data != 'undefined' && userAlerts.data.length > 0">
                    <thead>
                        <tr>
                            <th>Title</th>
                            <th>Message</th>
                            <th>Received</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr :key="'alert-'+index" v-for="(alert,index) in userAlerts.data" class="cursor-pointer" @click="seltAlert(alert)">
                            <td>
                                <span>
                                    {{ alert.title }}
                                </span>
                            </td>
                            <td>
                                <span class="truncate-text">
                                    {{ alert.message }}
                                </span>
                            </td>
                            <td>
                                {{ alert.created_at | moment('MMM DD @ HH:mm') }}
                            </td>
                            <td>
                                <span v-if="alert.status == 1" class="badge badge-primary">Read</span>
                                <span v-if="alert.status == 0" class="badge badge-danger">Unread</span>
                            </td>
                        </tr>
                    </tbody>
                </table> -->
                <div class="pagination-wrapper">
                    <pagination :data="userAlerts" @pagination-change-page="onChangePage" :limit="5"></pagination>
                </div>
            </div>
        </div>
    </div>

    <b-modal size="xl" hide-footer id="editDeliverableModal" title="" class="modal-edit-deliverable" @hide="editDeliverableModalHidden" @shown="pushRoute" @hidden="removeRoute">
        <EditModal :allContacts="allContacts"  ref="refEditModal"/>
    </b-modal>
  </div>
</template>

<script>
import toast from "../toast";
import HeaderControls from "../components/common/HeaderControls";
import CreateGlobalAlert from "../components/common/CreateGlobalAlert";
import EditModal from "../components/deliverables/EditModal";
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
    data() {
        return {
            alertTitle: '',
            alertDetail: '',
            alertTime: '',
            alertSender: '',
            deleteAlertId: '',
            confirmDeleteAlert: false
        }
    },
    components: {
        HeaderControls,
        CreateGlobalAlert,
        EditModal
    },
    computed: {
        ...mapGetters(['userAlerts','deliverableDetail','allContacts','taskHighlighted']),
    },
    mounted() {
        // this.fetchUserAlerts();
        
        this.$root.$on("bv::modal::shown", (bvModal, modalId) => {
            if (modalId == 'editDeliverableModal') {
                if (this.taskHighlighted) {
                    let editModal = $("#editDeliverableModal");

                    this.$nextTick(() => {
                        setTimeout(() => {
                            let curEl = $(".task-fields .field-block.highlight");
                            const elOffset = curEl.offset();
                            editModal.scrollTop(elOffset.top - 0.4 * window.innerHeight);
                        }, 100);
                    });
                }
            }
        })
    },
    methods: {
        ...mapActions(['fetchUserAlerts', 'fetchProjectDeliverableById', 'getProjectNumberFromId']),
        ...mapMutations(['setDataLoading']),
        onChangePage(data) {
            this.fetchUserAlerts(data);
        },
        deleteAlert(alertId) {
            this.$store.dispatch('deleteAlert', { alertId });
        },
        seltAlert(alert) {
            this.alertTitle = alert.title;
            this.alertDetail = alert.message;
            this.alertSender = alert.sender;
            this.alertTime = alert.created_at;
            // this.$bvModal.show('userGlobalAlertDetail');
            if(alert.status == 0) {
                this.$store.dispatch('makeAlertRead', {alert});
            }

            if (alert.alert_type == "deliverable") {
                let deliverableId = alert.model_id;
                
                this.$store.dispatch("getDeliverableDetail", { deliverableId })
                .then(() => {
                    let currentTitle = document.title.match(/\(\d+\)\s/g);
                    if(!currentTitle) {
                        document.title = this.deliverableDetail.title;
                    } else {
                        document.title = currentTitle[0] + this.deliverableDetail.title;
                    }
                    this.$bvModal.show("editDeliverableModal");
                });
            } else if (alert.alert_type == "project") {
                this.goToProject(alert.model_id);
            } else if (alert.alert_type == "task") {
                let taskId = alert.model_id;

                this.$store.dispatch("getDeliverableDetailByTask", { taskId })
                .then(() => {
                    let currentTitle = document.title.match(/\(\d+\)\s/g);
                    if(!currentTitle) {
                    document.title = this.deliverableDetail.title;
                    } else {
                    document.title = currentTitle[0] + this.deliverableDetail.title;
                    }
                    this.$store.dispatch("highlightTask", taskId);
                    this.$bvModal.show("editDeliverableModal");
                });
            } else {
                this.$bvModal.show("globalAlertDetail");
            }
        },

        goToProject(projectId) {
            this.setDataLoading(true);
            this.getProjectNumberFromId(projectId).then((projectNumber) => {
                this.fetchProjectDeliverableById(projectNumber).then(() => {
                    this.setDataLoading(false);
                    this.$router.push('/project/' + projectNumber);
                });
            })
        },

        getLocalAlertTime(time) {
            const alertTime = this.$moment.utc(time);
            alertTime.local();
            return alertTime.format('MMM Do, hh:mm a');
        },

        // Deliverable modal related
        editDeliverableModalHidden() {
			this.$store.commit('setDeliverable', this.deliverableDetail)
		},
        pushRoute() {
			if(this.$router.currentRoute.path.indexOf('deliverable/') == -1) {
				history.pushState(
					{},
					null,
					'deliverable/' + encodeURIComponent(this.deliverableDetail.id) + '/' + encodeURIComponent(this.deliverableDetail.slug)
				)
			}
		},
        removeRoute() {
			if(this.$router.currentRoute.path.indexOf('deliverable/') != -1) {
				this.$router.push({name: 'dashboard'});
			} else {
				history.pushState(
					{},
					null,
					this.$router.currentRoute.path
				);
				//this.$router.push(this.$router.currentRoute.path).catch(err => {console.log(err)});
			}
		},
    }
}
</script>

<style>

</style>